export default "<div class=\"loader\" *ngIf=\"!loaderService.toHide\"> <mat-spinner></mat-spinner> </div>\r\n"